module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Fieldset wraps a set of options (e.g. a group of radios). <strong>It is used by the CheckableGroup component and should not be used directly.</strong></p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Fieldset label=&quot;This will be the fieldset &lt;legend&gt; text&quot;&gt;\n    &lt;ul&gt;\n        &lt;li&gt;...option1...&lt;/li&gt;\n        &lt;li&gt;...option2...&lt;/li&gt;\n    &lt;/ul&gt;\n&lt;/Fieldset&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Fieldset/README.md
// module id = 348
// module chunks = 0